export function truncate(string, { n = 300, useWordBoundary = true } = {}) {
  if (string === null || string === undefined) {
    return null
  }

  if (string.length <= n) {
    return string
  }

  const subString = string.substr(0, n - 1)

  return `${
    useWordBoundary
      ? subString.substr(0, subString.lastIndexOf(" "))
      : subString
  }…`
}

export const compareStrings = (aString, bString) => {
  return String(aString)
    .toLowerCase()
    .localeCompare(String(bString).toLowerCase())
}
